export const API_MAIN_SERVER_URL =
    process.env.REACT_APP_API_MAIN_SERVER_URL || "http://localhost:5000"

// Which key is stocked the JWT token in the localstorage
export const SECURITY_JWT_KEY = "jwt_session"
